<template>
  <div>
    <el-row>
      <el-col :span="5">
        <el-switch style="display: block" v-model="draggableDisabled" active-color="#13ce66" inactive-color="#ff4949"
          active-text="开启移动" inactive-text="关闭移动">
        </el-switch>
      </el-col>
    </el-row>
    <el-row class="draggable_body">
      <el-col :span="7" :offset="1" class="draggle_one">
        <h3>普通会员</h3>
        <el-input placeholder="搜索">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <draggable class="list-group" :list="list1" group="people" @change="log" filter=''
          :disabled='!draggableDisabled'>
          <div class="list-group-item" v-for="element in list1" :key="element.name">
            {{ element.name }}
          </div>
        </draggable>
      </el-col>
      <el-col :span="7" :offset="1" class="draggle_two">
        <h3>理事会员</h3>
        <el-input placeholder="搜索">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <draggable class="list-group" :list="list2" group="people" @change="log" :disabled='!draggableDisabled'>
          <div class="list-group-item" v-for="element in list2" :key="element.name">
            {{ element.name }}
          </div>
        </draggable>
      </el-col>
      <el-col :span="7" :offset="1" class="draggle_three">
        <h3>秘书会员</h3>
        <el-input placeholder="搜索">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <draggable class="list-group" :list="list3" group="people" @change="log" :disabled='!draggableDisabled'>
          <div class="list-group-item" v-for="element in list3" :key="element.name">
            {{ element.name }}
          </div>
        </draggable>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
  name: 'two-lists',
  display: 'Two Lists',
  order: 1,
  components: {
    draggable
  },
  data() {
    return {
      draggableDisabled: false,
      list1: [
        { name: '普通会员1', id: 1 },
        { name: '普通会员2', id: 2 },
        { name: '普通会员3', id: 3 },
        { name: '普通会员4', id: 4 }
      ],
      list2: [
        { name: '理事会员1', id: 5 },
        { name: '理事会员2', id: 6 },
        { name: '理事会员3', id: 7 }
      ],
      list3: [
        { name: '秘书会员1', id: 5 },
        { name: '秘书会员2', id: 6 },
        { name: '秘书会员3', id: 7 }
      ]
    };
  },
  methods: {
    add: function() {
      this.list.push({ name: 'Juan' });
    },
    replace: function() {
      this.list = [{ name: 'Edgard' }];
    },
    clone: function(el) {
      return {
        name: el.name + ' cloned'
      };
    },
    log: function(evt) {
      window.console.log(evt);
    }
  }
};
</script>
<style lang="stylus" scoped>
h3 {
  text-align center
}
.list-group {
  div {
    text-align center
  }
  .list-group-item {
    cursor pointer
  }
}
.el-row.draggable_body {
  margin-top 20px
  .el-col {
    color #fff
    height 300px
    border-radius 18px
  }
  .draggle_one {
    background-color #BC8F8F
  }
  .draggle_two {
    background-color #CD5C5C
  }
  .draggle_three {
    background-color #8B0000
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/userCenter/member.vue